import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from '@services';
import { ProductEsignForm }from '@model';

@Injectable({
    providedIn: 'root'
  })
  export class AgreementService {
    constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}
    
    createProductAgreement(product: ProductEsignForm): Observable<number> {
      return this.http
        .post<number>(`${environment.apiEndpoint}/agreements/product`, product)
        .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    getAgreementLink(agreementId: number): Observable<string>{
      const headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
        return this.http
            .get<any>(`${environment.apiEndpoint}/agreements/${agreementId}/link`)
            .pipe(
              map(accessLink => accessLink.link),
              catchError((error: any) => this.sxErrorService.handleError(error))
              );
    }
  }